import { render, staticRenderFns } from "./WorkPlaces.vue?vue&type=template&id=3b651894&scoped=true&"
import script from "./WorkPlaces.vue?vue&type=script&lang=js&"
export * from "./WorkPlaces.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b651894",
  null
  
)

export default component.exports